// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SyncOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SyncOffIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 11c0-1.382 1.325-2.944 3.507-2.494C7.887 6.915 8.98 6 10 6c.556 0 1.677.11 2.39 1.501l1.09-1.09C12.685 5.132 11.518 4.5 10 4.5 8.38 4.5 6.956 5.63 6.302 7 3.905 6.743 2 8.79 2 11a4 4 0 0 0 3.013 3.878L6.39 13.5H6A2.5 2.5 0 0 1 3.5 11" />
      <path d="m10.633 13.5-1.5 1.5H15c1.696-.242 3-1.737 3-3.5 0-1.363-.948-2.58-2.185-3.182L14.723 9.41c1.775.522 1.825 1.79 1.777 2.09 0 1.005-.532 1.862-1.5 2z" />
      <path d="M4 15.75 15.314 4.436l1.06 1.06L5.061 16.812z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SyncOffIcon = /* @__PURE__ */ Object.assign(SyncOffIconComponent, {
  displayName: 'SyncOffIcon',
});
